import React from 'react';
import { useMoney } from "../../../hooks/useMoney";
import { DollarSign } from 'lucide-react';
import { PrincipalWalletBalanceItem } from '../../../features/principal/types';

interface PrincipalWalletCardProps {
  wallet: PrincipalWalletBalanceItem;
  onViewTransactions: (walletId: number, programName: string) => void;
}

const PrincipalWalletCard: React.FC<PrincipalWalletCardProps> = ({ wallet, onViewTransactions }) => {
  const { symbol, number } = useMoney();
  const formatAmount = (amount: number) =>
    number(amount, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const programName = wallet.program?.programName ?? wallet.name;

  const handleViewTransactions = () => {
    onViewTransactions(wallet.principalWalletId, programName);
  };

  return (
    <div className="relative border rounded-lg p-4 bg-white flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          {wallet.program?.logo && (
            <img
              src={wallet.program.logo}
              alt={programName}
              className="w-16 h-10 object-contain rounded-lg p-1"
            />
          )}
          <h3 className="text-lg font-semibold text-gray-900">
            {programName}
          </h3>
        </div>
        <div className="flex items-end">
          <button
            onClick={handleViewTransactions}
            className="px-4 py-2 text-sm font-medium text-brand border border-brand rounded-md hover:bg-brand hover:text-white focus:outline-none transition-colors flex items-center gap-2"
          >
            View Transactions
          </button>
        </div>
      </div>
      <div className="flex flex-row gap-6">
        <div className="flex-1">
          <h4 className="text-sm font-medium text-gray-700 mb-3">Wallet Details</h4>
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="flex flex-1 items-center gap-4 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 rounded-full bg-white">
                <DollarSign className="w-4 h-4 text-blue-600" />
              </div>
              <div>
                <p className="text-xs text-gray-600 font-medium">Current Balance</p>
                <p className="text-md mt-1 font-semibold text-gray-900">
                  {symbol}{formatAmount(wallet.balance)}
                </p>
              </div>
            </div>
            <div className="flex flex-1 items-center gap-4 p-3 bg-gray-50 rounded-lg">
              <div className="p-2 rounded-full bg-white">
                <DollarSign className="w-4 h-4 text-green-600" />
              </div>
              <div>
                <p className="text-xs text-gray-600 font-medium">Saral Amount</p>
                <p className="text-md mt-1 font-semibold text-gray-900">
                  {symbol}{formatAmount(wallet.saralAmount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrincipalWalletCard;
